<template>
<div>
  <Loading :loading="this.loading"></Loading>
  <div v-show="!loading" class="content-wrapper">
    <div class="container">
      <article>
        <section class="section white-panel mb12" v-if="this.hasBestMySs && !this.webviewMaintenance.carMainte">
          <p class="mb0 text-center mb8">
            <img src="/lib/images/mainte_reserve_sorry.png" class="" alt="">
          </p>
          <p class="mb0 text-center mb12">
            <img src="/lib/images/mainte_reserve_staff.png" class="" alt="">
          </p>
          <p class="fs14 mt4 mb12" v-if="this.isPitlockMaintenance">サービス準備中のため、申し訳ございませんがお時間をおいて再度お試し下さい。</p>
          <p class="fs14 mt4 mb12" v-if="!this.isCarMainteStore">この店舗ではカーメンテナンスはご利用いただけません。別の店舗で利用したい場合は、別の店舗を選択してから再度カーメンテ予約をタップしてください。</p>
          <button v-on:click='appChangeMySs()' class="mainte-reserve-search-button" v-if="!this.isCarMainteStore">
            <img src="/lib/images/mainte_reserve_search_icon.png" alt="検索" class="search-icon">
            店舗を探す
          </button>
          <div class="mainte-reserve-back-container">
            <a v-on:click='homeBack()' href="#" class="mainte-reserve-back-link">
              <img src="/lib/images/mainte_reserve_chevron_left.png" alt="戻る" class="mainte-reserve-back-arrow">
              戻る
            </a>
          </div>
        </section>
        <section class="section white-panel mb12" v-if="!this.hasBestMySs && !this.webviewMaintenance.carMainte">
          <div class="mainte-reserve-container">
            <div class="mainte-reserve-message">
              <p class="mainte-reserve-text">この機能の利用には</p>
              <p class="mainte-reserve-text-emphasis mb12">お気に入り店舗の登録が必要です</p>
              <p class="mb0 text-center">
                <img src="/lib/images/mainte_reserve_ss.png" class="" alt="">
              </p>
            </div>

            <button v-on:click='appChangeMySs()' class="mainte-reserve-favorite-button">
              <img src="/lib/images/mainte_reserve_star_icon.png" alt="" class="mainte-reserve-star-icon">
              お気に入り店舗を選択する
            </button>

            <div class="mainte-reserve-back-container">
              <a v-on:click='homeBack()' href="#" class="mainte-reserve-back-link">
                <img src="/lib/images/mainte_reserve_chevron_left.png" alt="戻る" class="mainte-reserve-back-arrow">
                戻る
              </a>
            </div>
          </div>
        </section>
        <section class="section white-panel mb12" v-if="this.webviewMaintenance.carMainte">
          <p class="mb0 text-center mb8">
            <img src="/lib/images/mainte_reserve_sorry.png" class="" alt="">
          </p>
          <p class="mb0 text-center mb12">
            <img src="/lib/images/mainte_reserve_staff.png" class="" alt="">
          </p>
          <p class="fs14 mt4 mb12">誠に申し訳ありませんが、ただいまメンテナンス中につき、ご利用いただくことが出来ません。お時間をあけてから再度アクセスをお願い致します。</p>
          <div class="mainte-reserve-back-container">
            <a v-on:click='homeBack()' href="#" class="mainte-reserve-back-link">
              <img src="/lib/images/mainte_reserve_chevron_left.png" alt="戻る" class="mainte-reserve-back-arrow">
              戻る
            </a>
          </div>
        </section>

      </article>
    </div>
  </div>
</div>
</template>

<script>
import modal from '@/assets/v3/modal'
import Loading from '@/views/v3/Loading.vue'
import appVerApi from '@/store/Api/Common/appVer'
import profileApi from '@/store/Api/Common/profile'
import ssApi from '@/store/Api/Common/ss'
import shopDetailsCallingApi from '@/store/Api/Pitlock/shopDetailsCalling'
import config from '@/v3/config'

export default {
  data () {
    return {
      loading: true,
      webviewMaintenance: [],
      profileInfo: [],
      ssInfo: [],
      isCarMainteStore: true,
      isPitlockMaintenance: false,
      hasBestMySs: true,
      unselectedSsCode: process.env.VUE_APP_UNSELECTED_SS_CODE
    }
  },
  methods: {
    openErrorModal (message) {
      modal.alert(message)
    },
    setWebviewMaintenance (webviewMaintenance) {
      this.webviewMaintenance = webviewMaintenance
    },
    setProfileInfo (profileInfo) {
      this.profileInfo = profileInfo
    },
    setSsInfo (ssInfo) {
      this.ssInfo = ssInfo
    },
    appChangeMySs () {
      if ('Android' in window) {
        /* eslint-disable-next-line no-undef */
        Android.changeMySs()
      } else if ('webkit' in window) {
        /* eslint-disable-next-line no-undef */
        webkit.messageHandlers.changeMySs.postMessage('')
      }
    },
    homeBack () {
      this.appHomeBack()
    }
  },
  computed: {
    nativeData: function () {
      const getData = {}
      // ネイティブから取得したデータを格納する。
      getData.tsid = this.$route.query.tsid
      getData.popinfoid = this.$route.query.popinfoid
      getData.otoken = this.$route.query.otoken
      return getData
    },
    versionData: function () {
      const getData = {}
      // ネイティブから取得したデータを格納する。
      getData.appVersion = this.$route.query.x_cls_app_version
      getData.platform = this.$route.query.x_cls_os
      getData.osVersion = this.$route.query.x_cls_os_version
      return getData
    }
  },
  async mounted () {
    console.log(location.href)
    // 戻るボタンの出し分け
    this.appDisplayBack(true)
    // タイトル
    this.appDisplayTitle('カーメンテ予約')
    let isApiError = false

    // webviewメンテナンス情報を取得
    await appVerApi.get().then(res => {
      this.setWebviewMaintenance(res.data.webviewMaintenance)
    }).catch(e => {
      console.log('appVerApi-error')
      console.log(e.message)
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    // バージョン情報が一つでも未定義の場合はエラーダイアログを表示.
    if (this.isCLSAppVersionError(this.$route.query.x_cls_app_version, this.$route.query.x_cls_os, this.$route.query.x_cls_os_version)) {
      this.openErrorModal('アプリバージョンの認証でエラーが発生しました。')
      isApiError = true
      return
    } else {
      this.versionData.appVersion = this.versionData.appVersion ? this.versionData.appVersion : '0.0.0'
      this.versionData.platform = this.versionData.platform ? this.versionData.platform : 'iRidge'
      this.versionData.osVersion = this.versionData.osVersion ? this.versionData.osVersion : '0.0'
    }

    // profile情報マスタ取得。
    await profileApi.get(this.nativeData.tsid, this.nativeData.otoken, this.appVersionMakeRequestHeder(this.versionData)).then(res => {
      this.setProfileInfo(res.data.body)
    }).catch(e => {
      console.log('profile-error')
      console.log(e.message)
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    // ベストMYSSが存在している場合
    if (this.profileInfo.best_myss !== null) {
      if (this.profileInfo.best_myss.code === this.unselectedSsCode) {
        // ベストMYSSが未選択の場合は、カーライフスクエア（700565）が設定されている
        this.hasBestMySs = false
      } else {
        await ssApi.get(this.profileInfo.best_myss.code).then(res => {
          this.setSsInfo(res.data.body.ss_info)
          // store_idが有り、且つカーメンテフラグが対応店の場合のみ、カーメンテメニューボタンを活性
          if (this.ssInfo.is_car_mainte === 1 && this.ssInfo.store_id) {
            this.isCarMainteStore = true
          } else {
            this.isCarMainteStore = false
          }
        }).catch(e => {
          console.log('ss-error')
          console.log(e.message)
          if (!isApiError) {
            this.openErrorModal('エラーが発生しました。')
            isApiError = true
          }
        })
      }
    } else {
      // ベストMYSSが存在していない場合
      this.hasBestMySs = false
    }

    if (this.hasBestMySs && this.isCarMainteStore && !this.webviewMaintenance.carMainte) {
      await shopDetailsCallingApi.get(this.ssInfo.store_id).then(res => {
        const pitlockshopDetails = res.data.body
        if (pitlockshopDetails.showable !== 1 || pitlockshopDetails.cls_mainte_flag !== 1) {
          // PITLOCK にてカーメンテナンスが非表示の場合
          this.isPitlockMaintenance = true
        } else {
          const timyCarMainteUrl = process.env.VUE_APP_TIMY_CAR_MAINTE_URL +
                this.ssInfo.store_id + '/?' +
                'reserve_channel=' + config.TIMY_CAR_MAINTE_RESERVE_CHANNEL_CODE +
                '&ts_id=' + this.nativeData.tsid +
                '&popinfo_id=' + this.nativeData.popinfoid +
                '&ss_code=' + this.ssInfo.ss_code +
                config.TIMY_CAR_MAINTE_CF_PARAM
          this.nativeEVENTSet('CarMainte_Button', 'MOVED_CarMainte', 'TAP')
          if ('Android' in window) {
            /* eslint-disable-next-line no-undef */
            Android.openBrowser(timyCarMainteUrl)
            Android.homeBack()
          } else if ('webkit' in window) {
            /* eslint-disable-next-line no-undef */
            webkit.messageHandlers.openBrowser.postMessage(timyCarMainteUrl)
            webkit.messageHandlers.homeBack.postMessage('')
          }
        }
      }).catch(e => {
        this.openErrorModal('ただいまアクセスが集中している可能性がございます。恐れ入りますが、時間をおいて再度お試しください。')
      })
    }

    if (!isApiError) {
      this.loading = false
    }
  },
  components: {
    Loading
  }
}

</script>
